// @flow
import React, { Fragment, Component } from 'react';
import Rater from 'react-rater';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import {
  Container,
  Row,
  Col,
  Button,
} from 'reactstrap';

import User from '../../User';
import config from '../../../config';
import makeUrl from '../../../lib/makeUrl';
import EditButton from '../NewEditButton';
import ImageUploader from '../../ImageUploader';
import { WhitePanel, SemiTransparentLoader, Toggler } from '../../UI';
import { isSuperUser } from '../../../lib/utils';
import HashLinkIntoView from '../../HashLinkIntoView';
import withTrekPermission from '../../../HOCs/withTrekPermission';
import JumbotronImageSlider from '../../JumbotronImageSlider';
import type { overviewJumbotrom } from '../../../types/trek';
import { useFallbackImage } from '../../../lib/utils';
import ConnectedPrimaryCTA from './PrimaryCTA';
import { componentNames as editorNames } from '../TrekOverviewModal';
import TrekPriceAndInclusions from './TrekPriceAndInclusions';

import './OverviewJumbotron.css';
import '../../../../node_modules/react-rater/lib/react-rater.css';
import { searchFlights } from '../../../redux/actions/trekPaymentReviewActions';

const fallbackUserAvatar = 'https://s3.amazonaws.com/honeyguide/assets/user-fallback.png';

function OverviewJumbotron(props: overviewJumbotrom) {
  const {
    id,
    name,
    author,
    region,
    is_owner,
    // is_guided,
    // starting_price,
    // price,
    number_of_days,
    isOwner,
    albums,
    // pax,
    isLoading,
    primary_image,
    is_bookable,
    banner_images,
    // preferences,
    static_price_npr,
    static_price_inr,
    static_price_usd,
    cta_url,
    // description,
    noOfReviews,
    rating,
    npr_inclusions,
    inr_inclusions,
    usd_inclusions,
  } = props;

  // const trekPrice = is_guided ? price : starting_price;

  let images;
  let primaryImage;
  const bannerImage: string = banner_images ? banner_images.large : primary_image;
  const bannerImageUrl = `${config.RESOURCE_URL}/${bannerImage}`;

  if (isEmpty(albums) || isEmpty(albums.images)) {
    images = [bannerImageUrl];
    primaryImage = [`${config.RESOURCE_URL}/${primary_image}`];
  } else {
    images = albums.images.map(img => `${config.RESOURCE_URL}/${img.primary_image}`);
  }

  // const totalPrice = is_bookable ? (pax * Number(trekPrice ? trekPrice.amount : 0)).toLocaleString() : 0;
  const hasStaticPrice = static_price_npr || static_price_inr || static_price_usd;

  // const includedPreferences = !isEmpty(preferences)
  //   ? preferences.filter(p => p.is_available)
  //   : null;

  // console.log('this is the included preferences', includedPreferences);

  const unBookableTrekBookSection = (
    <Fragment>
      <div className="trek-date">
        <div className="trek-date-days">
          <span>Duration</span>
          <span>
            <strong>{number_of_days} Days</strong>
          </span>
        </div>
      </div>
      <hr />
      <Link
        to={{
          pathname: '/onboarding-form',
          search: `?region=${region}`,
        }}
      >
        <Button color="yellow">Inquire this Trek</Button>
      </Link>
    </Fragment>
  );

  const StaticSummarySection = () => (
    <Col xl="4" xs="12">
      <WhitePanel className="white-panel-dark trek-details mb-0">
        <EditButton
          editorName={editorNames.TrekCTAAndPriceEditor}
          openModal={true}
        />
        <div className="stat-content-holder p-125">
          <div className="trek-info">
            <p>Since 2018, HoneyGuide has worked with over <strong>1000 independent/group trekkers</strong>, <strong>200+ Lodges</strong> and <strong>230+ Local Guides/Porters</strong> in the Everest Region.</p>
                As a concierge, HoneyGuide will:
                <ul>
              <li>Answer your queries and help you make an itinerary as per your budget, preference and time.</li>
              <li>Recommend and help you book Flights, Guides/ Porter and Lodges in every night stop at best rates.</li>
              <li>Full trail support- If any changes occur, we will change your scheduled bookings for free.</li>
            </ul>
          </div>

          {is_bookable ? (
            <Fragment>
              <div className="trek-date">
              </div>
              <div className="trek-action">
                <ConnectedPrimaryCTA />
                <p className="trek-action-other">
                  <a href="mailto:honeyhunter@honeyguideapps.com" style={{ textDecoration: "underline" }}>
                    Email
                        </a> |
                        <a href="tel:+9779801916215" style={{ textDecoration: "underline" }}>
                    Call: +977-9801916215
                        </a> | <a href="#faqs" style={{ textDecoration: "underline" }}>
                    FAQ's
                        </a>
                </p>
              </div>
              {isOwner ? (
                <div className="trek-message">You are the owner of this trek.</div>
              ) : null}
            </Fragment>
          ) : (
              unBookableTrekBookSection
            )}

          <hr />
          <h6 className="">We are featured by</h6>
          <div className="social-list">
            {SocialProofs.map(({ link, src }) => (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                key={link}
              >
                <img src={src} alt="LP" />
              </a>
            ))}
          </div>
        </div>
      </WhitePanel>
      {is_bookable && (
        <MobileStickBar targetId="primaryCTA">
          <ConnectedPrimaryCTA handleAfterError={() => window.scrollTo(100, 100)} />
        </MobileStickBar>
      )}
    </Col>
  );

  const SummarySection = () => (
    <Col xl="4" xs="12">
      <WhitePanel className="white-panel-dark trek-details stat mb-0">
        <EditButton editorName={editorNames.TrekCTAAndPriceEditor} openModal={true} />
        <TrekPriceAndInclusions npr={static_price_npr} inr={static_price_inr} usd={static_price_usd} nprInclusions={npr_inclusions} inrInclusions={inr_inclusions} usdInclusions={usd_inclusions} />
        <div className="stat-content-holder">
          <div className="stat-rating-wrap">
            <h6>{rating}</h6>
            <Rater
              total={5}
              rating={rating}
              interactive={false}
            />
            <p>{noOfReviews} reviews</p>
          </div>
          <div className="trek-action">
            <div id="newPrimaryCTA">
              <a className="btn btn-yellow" href={cta_url} target="_blank" rel="noopener noreferrer"> SEND US A MESSAGE</a>
            </div>
            <p className="trek-action-other">
              <a href="mailto:honeyhunter@honeyguideapps.com" style={{ textDecoration: "underline" }}>Email</a> | <a href="tel:+9779801916215" style={{ textDecoration: "underline" }}>Call: +977-9801916215</a> | <a href="tel:+9779801916215" style={{ textDecoration: "underline" }}>Whatsapp</a>
            </p>
          </div>
          <hr />
          <h6 className="">We are featured by</h6>
          <div className="social-list">
            {SocialProofs.map(({ link, src }) => (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                key={link}
              >
                <img src={src} alt="LP" />
              </a>
            ))}
          </div>
        </div>
      </WhitePanel>
      <MobileStickBar targetId="newPrimaryCTA">
        <div id="primaryCTA">
          <a className="btn btn-yellow" href={cta_url} target="_blank" rel="noopener noreferrer">SEND US A MESSAGE</a>
        </div>
      </MobileStickBar>
    </Col>
  );

  const renderSummarySection = () => {
    const hasInclusions = usd_inclusions || inr_inclusions || npr_inclusions;
    return hasInclusions && hasStaticPrice && cta_url ? <SummarySection /> : <StaticSummarySection />;
  };

  return (
    <Fragment>
      <HashLinkIntoView />
      <SemiTransparentLoader isLoading={isLoading} loadingText="Preparing Your Trek" />
      <Container>
        <div className="white-panel trek">
          <div className="trek-wrapper">
            <div className="trek-wrapper-title">
              {region && (
                <span
                  className="trek-region"
                  style={{ marginBottom: '0', fontSize: '14px', fontWeight: '400' }}
                >
                  <a href={makeUrl.goToRegionInfo(region)}>{`${region} Region`}</a>
                </span>
              )}

              <h1
                className="trek-title"
                id="sd-trek-name"
                data-trek-name={`${name} - ${number_of_days} Days`}
              >
                {name} - {number_of_days} Days
                <EditButton
                  editorName={editorNames.TrekNameAndDateEditor}
                  openModal={true}
                />
              </h1>
            </div>
            <div className="trek-wrapper-owner">
              <User userId={author ? author : 'uId'}>
                {({ userData }) => {
                  const { avatar, fullname } = userData;
                  const avatarImage = `${config.RESOURCE_URL}/${avatar}`;
                  return (
                    <div className="trek-owner user-holder clearfix">
                      <div className="trek-owner-image">
                        <img
                          src={avatarImage}
                          alt={fullname ? fullname : ''}
                          className="rounded-circle"
                          onError={e => useFallbackImage(e, fallbackUserAvatar)}
                          height="28"
                          width="28"
                        />
                      </div>
                      <div className="trek-owner-detail">
                        Created By <br />
                        <Link to={makeUrl.goToProfile(fullname, author ? author : 'id')}>
                          {fullname ? fullname : 'Unknown'}
                        </Link>
                      </div>
                    </div>
                  );
                }}
              </User>
            </div>
          </div>
          <Row>
            <Col xs="12" xl="8">
              <div className="trek-image-slider" id="sd-trek-image" data-trek-image={bannerImageUrl}>
                <ImageUploader
                  uploadUrl={`trips/treks/${id}/cover_image`}
                  role={is_owner || isSuperUser()}
                  pageContext="trekOverview"
                  multiple={true}
                >
                  {imgUrl => {
                    return (
                      <JumbotronImageSlider
                        showNav
                        images={images}
                        primaryImageUrl={primaryImage}
                        uploadedUrls={imgUrl}
                      />
                    );
                  }}
                </ImageUploader>
              </div>
            </Col>

            {renderSummarySection()}

          </Row>
        </div>
      </Container>
    </Fragment>
  );
}

const SocialProofs = [
  {
    link:
      'https://www.lonelyplanet.com/news/2016/06/29/nepal-goes-hi-tech-new-app-trekking/',
    src: 'https://s3.amazonaws.com/honeyguide/assets/lp-gray.png',
  },
  {
    link: 'http://www.infodev.org/articles/transforming-tourism-nepal-one-trek-time',
    src: 'https://s3.amazonaws.com/honeyguide/assets/wb-gray.png',
  },
  {
    link: 'https://www.kimkim.com/c/best-apps-for-nepal',
    src: 'https://s3.amazonaws.com/honeyguide/assets/kk-gray.png',
  },
];

const mapStateToProps = ({
  ratingsState,
  reviewsState: { reviews },
  trekPayment: {
    noOfPeople,
    trekTemplateStartDate,
    isFlightsAvailable,
    isLoading,
    userIsPickingDatesOrPax,
  },
  selectedTrek: { childTreks, preferences },
}) => ({
  noOfReviews: reviews && reviews.length,
  rating: (ratingsState.ratings && ratingsState.ratings.rating) ? ((ratingsState.ratings.rating) / 2).toFixed(1) : 0,
  pax: Number(noOfPeople),
  startDate: trekTemplateStartDate,
  noFlights: isFlightsAvailable === false && !userIsPickingDatesOrPax,
  isLoading,
  doesTrekHaveChildTreks: childTreks && !isEmpty(childTreks.treks),
  preferences,
});

const mapDispatchToProps = dispatch => ({
  searchFlights: (onSuccess, onFailure) => dispatch(searchFlights(onSuccess, onFailure)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTrekPermission(OverviewJumbotron)));

type PriceProps = {
  targetId: String,
};

const observerOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 1,
};

class MobileStickBar extends Component<PriceProps> {
  observer: Object;
  showStickyBar: Function;
  hideStickyBar: Function;

  componentDidMount() {
    this.setupObserver();
  }

  setupObserver = () => {
    this.observer = new IntersectionObserver(
      args => (args[0].isIntersecting ? this.hideStickyBar() : this.showStickyBar()),
      observerOptions
    );

    const target = document.querySelector(`#${this.props.targetId}`);
    if (target) {
      this.observer.observe(target);
    }
  };

  render() {
    return (
      <Toggler>
        {({ on, open, close }) => {
          this.showStickyBar = open;
          this.hideStickyBar = close;
          console.log('sticky', on);

          return on ? (
            <div className="d-block d-lg-none">
              <div className="white-panel trek stick-bar-mobile mb-0">
                <div>
                  <p style={{ fontSize: '12px' }}>
                    <strong>Would you like to inquire?</strong>
                  </p>
                </div>
                {this.props.children}
              </div>
            </div>
          ) : null;
        }}
      </Toggler>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrekDetail/DayOverview/OverviewJumbotron.jsx